import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "adoption-search-scholarship-eligibility-toggle",
  class AdoptionSearchScholarshipEligibilityToggle extends WYATTElement {
    constructor() {
      super();

      this.containerElement = this.closest(".adoption-search--results");
    }

    get allIneligibleTextbookSummaries() {
      return Array.from(
        this.containerElement.querySelectorAll(
          "scholarship-eligibility-indicator"
        )
      )
        .filter((indicator) => {
          const { eligible } = indicator.dataset;
          return eligible === "false" || eligible === undefined;
        })
        .map((indicator) => indicator.closest(".product-textbook-summary"));
    }

    get templates() {
      return {
        scholarshipEligibilityToggle: document.getElementById(
          "adoption-search-scholarship-eligibility-toggle"
        ).content,
      };
    }

    handleChange(event) {
      const isChecked = event.target.checked;

      if (isChecked) {
        this.allIneligibleTextbookSummaries.forEach((summary) => {
          summary.classList.add("hidden");
        });
      } else {
        this.allIneligibleTextbookSummaries.forEach((summary) => {
          summary.classList.remove("hidden");
        });
      }
    }

    render() {
      const template =
        this.templates.scholarshipEligibilityToggle.cloneNode(true);

      this.appendChild(template);

      const inputElement = this.querySelector("[data-input]");

      inputElement.addEventListener("change", this.handleChange.bind(this));
    }
  }
);
